import { render, staticRenderFns } from "./TheComponent.vue?vue&type=template&id=309eaf59"
import script from "./TheComponent.vue?vue&type=script&lang=ts"
export * from "./TheComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModulesTheBanner: require('/usr/src/nuxt-app/components/modules/TheBanner.vue').default})
